import React, { useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import Logo from './Logo';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const history = useHistory();
    const location = useLocation();

    const handlePricingClick = (e) => {
        e.preventDefault();
        if (location.pathname !== '/') {
            history.push('/');
            setTimeout(() => {
                const pricingSection = document.getElementById('pricing');
                if (pricingSection) {
                    pricingSection.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        } else {
            const pricingSection = document.getElementById('pricing');
            if (pricingSection) {
                pricingSection.scrollIntoView({ behavior: 'smooth' });
            }
        }
        setIsOpen(false);
    };

    return (
        <nav className="sticky top-0 z-50 bg-gradient-to-r from-[#2f3b52] to-[#1a1a1a] shadow-xl border-b border-gray-600">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-20">
                    <Link to="/" className="flex items-center space-x-3 group">
                        <Logo className="w-12 h-12 transform group-hover:scale-110 transition-transform duration-300" />
                        <h1 className="text-3xl font-bold text-white tracking-wide group-hover:text-[#f7876f] transition-colors duration-300">
                            WebAura
                        </h1>
                    </Link>
                    <ul className="hidden md:flex space-x-8">
                        <li>
                            <Link 
                                to="/" 
                                className="text-white hover:text-[#f7876f] transition-colors duration-200 text-lg font-medium"
                            >
                                Accueil
                            </Link>
                        </li>
                        <li>
                            <Link 
                                to="/order" 
                                className="text-white hover:text-[#f7876f] transition-colors duration-200 text-lg font-medium"
                            >
                                Commander
                            </Link>
                        </li>
                        <li>
                            <a 
                                href="#pricing" 
                                onClick={handlePricingClick}
                                className="text-white hover:text-[#f7876f] transition-colors duration-200 text-lg font-medium cursor-pointer"
                            >
                                Tarifs
                            </a>
                        </li>
                    </ul>
                    <div className="md:hidden">
                        <button 
                            onClick={() => setIsOpen(!isOpen)}
                            className="text-white focus:outline-none hover:text-[#f7876f] transition-colors"
                        >
                            {isOpen ? (
                                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            ) : (
                                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            )}
                        </button>
                    </div>
                </div>

                {/* Mobile Menu */}
                {isOpen && (
                    <div className="md:hidden pb-4 animate-fade-in">
                        <ul className="space-y-2">
                            <li>
                                <Link 
                                    to="/" 
                                    onClick={() => setIsOpen(false)}
                                    className="block text-white hover:text-[#f7876f] hover:bg-white/10 transition-all duration-200 text-lg font-medium py-3 px-4 rounded-lg"
                                >
                                    Accueil
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/order" 
                                    onClick={() => setIsOpen(false)}
                                    className="block text-white hover:text-[#f7876f] hover:bg-white/10 transition-all duration-200 text-lg font-medium py-3 px-4 rounded-lg"
                                >
                                    Commander
                                </Link>
                            </li>
                            <li>
                                <a 
                                    href="#pricing" 
                                    onClick={handlePricingClick}
                                    className="block text-white hover:text-[#f7876f] hover:bg-white/10 transition-all duration-200 text-lg font-medium py-3 px-4 rounded-lg cursor-pointer"
                                >
                                    Tarifs
                                </a>
                            </li>
                        </ul>
                    </div>
                )}
            </div>
        </nav>
    );
};

export default Navbar;